import React, { useEffect, useState } from "react";
// import PdfViewer from "./PdfViewer";
import { Box, Button, ButtonGroup, Heading, HStack, IconButton, Tooltip } from "@chakra-ui/react";
// import { MdWidthFull } from "react-icons/md";
import styles from "./Rawlog.module.css"
import { Resize1, Resize2 } from "./icons";
// import { useNavigate } from "react-router-dom";

function RawLog(props) {
  const [toggle, setToggle] = useState(true);
  const [data, setData] = useState();
  // const { hash } = useNavigate();

  useEffect(() => {
    setData(props.data)
  }, [props.data])

  const errorLog = () => {
    const errorregex = new RegExp(/s*![^.?]*/gms);
    let error;
    let errors = [];
    while ((error = errorregex.exec(data)) !== null) {
      errors.push(error)
    }
    let render;
    if (errors.length > 0) {
      render = errors?.map((item, i) => (
        <div key={i} className={styles.errorbox_outer}>
          <p>{item}</p>
        </div>
      ))
    } else {
      render = (<div><p>No error's to show. Please check the Raw log.</p></div>)
    }
    return render;
  }

  return (
    <>
      <div className={styles.header}>
        <HStack
          backgroundColor="#454443"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1">
            <Tooltip label="Error Log">
              <Button
                onClick={() => {
                  setToggle(true)
                }}
                bg={toggle === true ? "#222" : ""}
                color="white"
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "#222" }}
              >Error Log</Button>
            </Tooltip>
            <Tooltip label="Raw Log">
              <Button
                onClick={() => {
                  setToggle(false)
                }}
                color="white"
                bg={toggle === false ? "#222" : ""}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "#222" }}
              >Raw Log</Button>
            </Tooltip>
            <Box position={"absolute"} right={0}>
              {props.pdfFull ? (
                <Tooltip label="Minimize PDF">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                    }}
                    size="lg"
                    bg="#454443"
                    aria-label="Resize pdf"
                    icon={<Resize2 />}
                    _hover={{ bg: "#222" }}
                  ></IconButton>
                </Tooltip>
              ) : (
                <Tooltip label="Maximize PDF">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                      // setClientWidth(1);
                    }}
                    size="lg"
                    colorScheme="#f47c0d"
                    aria-label="Resize pdf"
                    icon={<Resize1 />}
                    bg="#454443"
                    _hover={{ bg: "#222" }}
                  ></IconButton>
                </Tooltip>
              )}
            </Box>

          </ButtonGroup>
        </HStack>
      </div>
      <div className={styles.rawlogoutput} style={{ width: "100%", overflow: "auto" }}>
        {props.data !== "" ? (
          toggle ? (
            <div style={{ width: "100%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "93%", textWrap: "wrap" }}>{errorLog()}</p></pre>
            </div>
          ) : (
            <div style={{ width: "85%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "600px", textWrap: "wrap" }}>{props.data}</p></pre>
            </div>
          )
        ) : (
          <div style={{ height: "100%", alignItems: "center", display: "flex", justifyContent: 'center', paddingTop: "50px" }}>
            <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "500" }}>No Logs to Show</p>
          </div>
        )}
      </div>
    </>
  );
}


export default RawLog;
